import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../authContext';
import { useModal } from '../../contexts/ModalContext/ModalContext';

const SellerRoute = ({ children }) => {
    const { currentUser } = useAuth();
    const { showModal } = useModal();  // Esta función debe mostrar el modal
    const navigate = useNavigate();
    
    const [hasRedirected, setHasRedirected] = useState(false);

    const isAdmin = currentUser && currentUser.photoURL === "admin";

    useEffect(() => {
        if (!isAdmin && !hasRedirected) {
            // Muestra el modal una sola vez
            showModal(
                <>
                    <h2>Acceso Restringido</h2>
                    <p>
                        Parece que no tienes permisos para acceder a este sitio aún. 
                        Por favor, contáctanos para más información.
                    </p>
                    <button
                        onClick={() => {
                            window.location.href = "mailto:contacto@empresa.com";
                        }}
                        className="btn btn-primary"
                    >
                        Contáctanos
                    </button>
                </>
            );
            setHasRedirected(true);
            navigate("/", { replace: true });
        }
    }, [isAdmin, showModal, navigate, hasRedirected]);

    return isAdmin ? children : null;
};

export default SellerRoute;
